import * as _ from 'lodash'
import { parseDate } from "../common/Util"
import LazyResource from "./LazyResource"
import DerivedLazyResource from "./DerivedLazyResource"

abstract class BaseModel {
  protected visibleProps?: string[]
  protected hiddenProps?: string[]

  getCasts () {
    return {}
  }

  init (data = {}) {
    Object.getOwnPropertyNames(data).forEach(k => {
      const setterMethod = this[`set${_.upperFirst(k)}`]

      if (this[k] instanceof LazyResource) {
        this[k].current = setterMethod ? setterMethod(data[k], data) : data[k]
      } else if (setterMethod) {
        this[k] = setterMethod(data[k], data)
      } else if (this.isSafeProperty(data[k])) {
        const cast = this.getCasts()[k]

        if (cast === 'datetime') {
          this[k] = data[k] ? parseDate(data[k]) : undefined
        } else if (cast === 'number') {
          this[k] = data[k] === undefined
            ? undefined
            : data[k] === null
              ? null
              : Number(data[k])
        } else if (cast === 'boolean') {
          this[k] = data[k] === undefined
            ? undefined
            : data[k] === null
              ? null
              : !!data[k]
        } else {
          this[k] = data[k]
        }
      }
    })

    return this
  }

  private isSafeProperty (o: any) {
    // try to avoid messing with properties that don't look like fields
    return !(o instanceof LazyResource)
      && !(o instanceof DerivedLazyResource)
      && !_.isFunction(o)
  }

  toObject = () => {
    const props = _.filter(this.visibleProps || Object.getOwnPropertyNames(this), p => this.isSafeProperty(this[p]) && (!this.hiddenProps || !this.hiddenProps.indexOf(p)))

    const out = {}
    props.forEach(p => {
      if (this[p] && this[p].toObject) {
        out[p] = this[p].toObject()
      } else {
        out[p] = this[p]
      }
    })
    return out
  }
}

export default BaseModel